import React, { useCallback, useState } from 'react';
import {
  ATMField,
  ATMHeader,
  ATMSegment,
  ATMGrid,
  ATMInput,
  formatPhoneNumber,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import DropdownEmployee from 'src/components/atoms/dropdown/dropdown-employee/dropdown-employee.component';
import { useEmployeeContext } from 'src/contexts/employee.context';
import { IEmployee } from 'src/models/employee.model';
import BlockEmployee from 'src/components/atoms/block-employee/block-employee.component';
import { IRequestFormMethods } from 'src/models/request.model';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';
import styles from './flight-request-emergency-poc-form.module.scss';

type IProps = IRequestFormMethods;

const FlightRequestEmergencyPocForm: React.FC<IProps> = ({ control, errors }) => {
  const { state } = useEmployeeContext();
  const [employee, setEmployee] = useState<IEmployee>();

  const handleSearch = useCallback(
    (user, override = true) => {
      if (user) {
        const hasExistingPocPhone = Boolean(
          (control.defaultValuesRef?.current as any)?.request?.pocPhone
        );

        control.setValue(
          'request.pocName',
          `${user.first_name} ${user.last_name}`
        );
        control.setValue('request.pocDept', user.dept_org_desc);
        control.setValue('request.pocEmail', user.e_mail_address);
        control.setValue('request.pocJobTitle', user.job_title);
        control.setValue('request.pocManagerEmail', user.mgr_e_mail_address);
        control.setValue(
          'request.pocManagerName',
          `${user.mgr_first_name} ${user.mgr_last_name}`
        );
        if ((!override && !hasExistingPocPhone) || override) {
          control.setValue(
            'request.pocPhone',
            formatPhoneNumber(user.work_phone_1)
          );
        }
      }

      setEmployee(user);
    },
    [state, control, setEmployee]
  );

  return (
    <ATMSegment>
      <ATMHeader>{Lang.TTL_REQUEST_EMERGENCY_POC}</ATMHeader>

      <ATMGrid columns={3}>
        <ATMGrid.Column>
          <ATMField
            name="request.pocNo"
            label={
              <LabelRequired>
                {Lang.LBL_REQUEST_POC_EMPLOYEE}
              </LabelRequired>
            }
            control={control}
            as={DropdownEmployee}
            onChange={([_, { value }, user]: any) => {
              handleSearch(user, true);

              return value;
            }}
            onLoad={(user) => {
              handleSearch(user, false);
            }}
            icon="search"
            clearable
            error={errors.request?.pocNo}
          />
          <ATMField
            name="request.pocName"
            control={control}
            as={ATMInput}
            type="hidden"
            className="hidden"
          />
          <ATMField
            name="request.pocDept"
            control={control}
            as={ATMInput}
            type="hidden"
            className="hidden"
          />
          <ATMField
            name="request.pocJobTitle"
            control={control}
            as={ATMInput}
            type="hidden"
            className="hidden"
          />
          <ATMField
            name="request.pocEmail"
            control={control}
            as={ATMInput}
            type="hidden"
            className="hidden"
          />
          <ATMField
            name="request.pocManagerName"
            control={control}
            as={ATMInput}
            type="hidden"
            className="hidden"
          />
          <ATMField
            name="request.pocManagerEmail"
            control={control}
            as={ATMInput}
            type="hidden"
            className="hidden"
          />
        </ATMGrid.Column>
        <ATMGrid.Column>
          <ATMField
            name="request.pocPhone"
            label={
              <LabelRequired>
                {Lang.LBL_REQUEST_POC_CONTACT}
              </LabelRequired>
            }
            as={ATMInput}
            control={control}
            error={errors.request?.pocPhone}
            isPhone
            onChange={([_, { value }]) => value}
          />
        </ATMGrid.Column>
      </ATMGrid>

      {employee && (
        <BlockEmployee className={styles.employee} data={employee} />
      )}
    </ATMSegment>
  );
};

export default FlightRequestEmergencyPocForm;
